export default __webpack_public_path__ + "static/icon-21-1-06e59c2d5edf8e41a3491883bac21e46.png";